import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import Button from 'shopper/components/Button';
import Text from 'shopper/components/Text';

import { useModal } from 'providers/ModalProvider';
import { useUser } from 'providers/UserProvider';

import TextWithEllipsis from '../TextWithEllipsis';

import ACTIONS from 'constants/action';
import FOOTER from 'constants/footer';
import LINKS from 'constants/links';

const LoginModal = dynamic(() => import('components/LoginModal'), {
  ssr: false,
});

const COMPLETE_DESCRIPTION = [
  'O Promobit é a maior comunidade de ofertas do Brasil e por aqui o que não faltam são produtos em promoção, já que por dia são mais de 1 mil ofertas compartilhadas por nossa comunidade. Todas elas passam por um criterioso processo de validação que garante que apenas as ofertas de verdade e disponíveis em lojas confiáveis sejam compartilhadas na plataforma.',
  'Porém, a comunidade do Promobit não contribui apenas com o compartilhamento de promoções, já que os membros da comunidade também estão presentes nas ofertas publicadas através de comentários e reviews, proporcionando uma grande troca de informações e experiências com produtos entre os usuários, dando suporte para que os usuários do Promobit façam sua decisão de compras, seja nas ofertas de eletrodomésticos, de itens para home office ou em games.',
  'Aqui você também encontra muitos cupons de desconto para as principais varejistas como Casas Bahia, Americanas e Madeira Madeira. Em nossa página de cupons de desconto você também encontra cupons exclusivos do Promobit e consegue obter aquele desconto que faltava para chegar ao valor que deseja pagar. Basta pegar o cupom na página do Promobit e garantir um preço final menor.',
  'Já a ferramenta de lista de desejos é de grande serventia para informá-lo quando um produto em promoção está disponível. Basta adicionar o produto que deseja comprar e quando ele estiver em oferta, seja um novo fogão, geladeira e demais eletrodomésticos baratos, o Promobit te avisa.',
  'A variedade de ofertas no Promobit é muito grande ao longo de todo o ano, porém, é durante Black Friday que as melhores condições de compras aparecem, seja por cupom de desconto ou com preços bem abaixo da média do mercado. A Black Friday acontece anualmente no último final de semana de novembro e para não perder nenhuma oportunidade de compra durante a Black Friday basta ficar atento ao Promobit e garantir a economia.',
];

const WhatIsPromobitDescription = () => {
  const { showModal } = useModal();
  const { pathname } = useRouter();
  const { isLoggedIn } = useUser();

  return (
    <>
      {pathname === LINKS.HOME ? (
        <TextWithEllipsis as="span" maxHeight={330} maxLines={14} withShowMore>
          {COMPLETE_DESCRIPTION.map((text, index) => (
            <Text key={index} size="size1" fontSize={[16, null, null, 14]}>
              {text}
            </Text>
          ))}
        </TextWithEllipsis>
      ) : (
        <>
          <Text size="size1" mb={4} fontSize={[16, null, null, 14]}>
            {FOOTER.WHAT_IS.DESCRIPTION}
          </Text>
          {!isLoggedIn && (
            <Button
              type="secondary"
              size="size2"
              full
              onClick={() => showModal(LoginModal, { isOpen: true })}
            >
              {ACTIONS.SIGN_UP}
            </Button>
          )}
        </>
      )}
    </>
  );
};

export default WhatIsPromobitDescription;
